'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders the error div.
 * @extends {Component}
 */
var ErrorDivComponent = function (_React$Component) {
  _inherits(ErrorDivComponent, _React$Component);

  function ErrorDivComponent() {
    _classCallCheck(this, ErrorDivComponent);

    return _possibleConstructorReturn(this, (ErrorDivComponent.__proto__ || Object.getPrototypeOf(ErrorDivComponent)).apply(this, arguments));
  }

  _createClass(ErrorDivComponent, [{
    key: 'findErrors',
    value: function findErrors(object, result) {
      if (!object) {
        return result;
      }

      if (object.invalid && object.touched) {
        result.push(object.error);
      }

      for (var i = 0; i < Object.keys(object).length; i++) {
        if (_typeof(object[Object.keys(object)[i]]) === 'object') {
          this.findErrors(object[Object.keys(object)[i]], result);
        }
      }
      return result;
    }
  }, {
    key: 'displayErrors',
    value: function displayErrors(errors) {
      if (errors.length > 0) {
        var msgType = errors[0];
        if (msgType === 'success') {
          errors.shift();
          return _react2.default.createElement(
            'div',
            { className: 'alert alert-success', role: 'alert' },
            errors.map(function (error, index) {
              return _react2.default.createElement(
                'li',
                { key: index },
                error
              );
            })
          );
        }
        return _react2.default.createElement(
          'div',
          { className: 'alert alert-danger', role: 'alert' },
          _react2.default.createElement(
            'p',
            { className: 'bg-danger' },
            (0, _translate.t)('Please review your application as we found the following error(s)'),
            ':'
          ),
          errors.map(function (error, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              error
            );
          })
        );
      }
      return undefined;
    }
  }, {
    key: 'render',
    value: function render() {
      if (Array.isArray(this.props.fields)) {
        return _react2.default.createElement(
          'div',
          null,
          this.displayErrors(this.props.fields)
        );
      }
      var errors = this.findErrors(this.props.fields, []);
      return _react2.default.createElement(
        'div',
        null,
        this.displayErrors(errors)
      );
    }
  }]);

  return ErrorDivComponent;
}(_react2.default.Component);

ErrorDivComponent.propTypes = {
  fields: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.array, _react2.default.PropTypes.object]).isRequired
};
exports.default = ErrorDivComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/ErrorDivComponent.jsx
// module id = 272
// module chunks = 0